import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../shared/service/auth.service';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../shared/service/session.service';
import {SysConfigService} from '../../shared/service/sys-config.service';
import {AppConfig} from '../../shared/dto/app-config.model';
import swal, {default as Swal} from 'sweetalert2';
import {UserDetailModel} from '../../shared/dto/user-detail.model';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  @Input()
  public appConfig: AppConfig;
  public userId: number;
  public isMatch = true;

  public formError = '';
  public loginForm: FormGroup;

  constructor(private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private sysConfigService: SysConfigService,
              private sessionService: SessionService,
              private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      cpassword: new FormControl('', [Validators.required]),
      npassword: new FormControl('', [Validators.required]),
      cfpassword: new FormControl('', [Validators.required]),
    });
  }

  get username() {
    return this.tokenStorageService.getUserObjectToken().username;
  }

  get cpassword() {
    return this.loginForm.get('cpassword');
  }

  get npassword() {
    return this.loginForm.get('npassword');
  }

  get cfpassword() {
    return this.loginForm.get('cfpassword');
  }


  login(){
    this.matchPassword();
  }

  matchPassword(): void {
    const value = this.loginForm.value;
    if (value.npassword !== '' && value.cfpassword !== '') {
      if (value.npassword === value.cfpassword) {
        this.isMatch=true;
        const login: UserDetailModel = new UserDetailModel(this.tokenStorageService.getUserObjectToken().username,this.loginForm.value.cfpassword,null,null,null
          ,null,null,this.tokenStorageService.getUserObjectToken().employeeId,null,null,null,null,null);

        this.authService.resetPassword(login).subscribe(
          (success: string) => {
            Swal.fire("Success", "Password Reset Successfully", "success");
            this.router.navigate([``], { relativeTo: this.route });
          }
        )
      } else {
        this.isMatch=false;
        Swal.fire("Error", "Password do not match", "error");
      }
    }
  }


}
